import { TMultiValue, TOptionValue, TSingleValue } from './types';

export const singleToMulti = <TGroupName extends string = string>(value: TSingleValue<TGroupName>): Partial<TMultiValue<TGroupName>> => {
  return {
    [value.group]: [value.value],
  } as Partial<TMultiValue<TGroupName>>;
};
export const multiToSingle = <TGroupName extends string = string>(value: Partial<TMultiValue<TGroupName>>): TSingleValue<TGroupName> | null => {
  const firstFoundValue = Object.entries(value).find(([, groupValue]: [string, TOptionValue[]]) => groupValue.length);

  if (firstFoundValue) {
    return {
      group: firstFoundValue[0] as TGroupName,
      value: firstFoundValue[1][0],
    };
  }

  return null;
};
